import Cookies from 'js-cookie'

export default {

  block(requires, to, from, next) {
    const handle = this._handleFor[requires];

    if (handle) {
      return handle(to, from, next);
    }

    return false;
  },

  // IMPORTANT: each must execute next() if need to block the routing
  _handleFor: {

    guest(to, from, next) {
      const isBlocked = Cookies.get('token');

      if (isBlocked) {
        next('/dashboard/assessments');
      }

      return isBlocked;
    },

    authenticated(to, from, next) {
      const isBlocked = !Cookies.get('token');

      if (isBlocked) {
        next({
          path: '/',
          query: {
            sessionExpired: 1,
          },
        });
      }

      return isBlocked;
    },
    admin(to, from, next) {
      const isBlocked = Cookies.get('role') !== 'admin';

      if (isBlocked) {
        next('/');
      }

      return isBlocked;
    },

  },

};
